import React, { useState } from "react";
import "./index.scss";
import s from "./index.module.scss";
import YandexShare from "react-yandex-share";
import classNames from "classnames/bind";
const cx = classNames.bind(s);

const Share = () => {
	const [ready, setReady] = useState(false);

	return (
		<div className={`icon white mobile ${cx(s.share, { ready: ready })}`}>
			<YandexShare
				hooks={{
					onready: () => setReady(true)
				}}
				content={{
					url: "https://photos2019.tass.ru/",
					title: "100 моментов 2019 года в фотографиях ТАСС",
					description: " "
				}}
				theme={{
					lang: "en",
					bare: true,
					services: "vkontakte,facebook,twitter,odnoklassniki"
				}}
				contentByService={{
					vkontakte: {
						image: "https://photos2019.tass.ru/images/vk.png"
					},
					twitter: {
						image: "https://photos2019.tass.ru/images/tw.png"
					},
					odnoklassniki: {
						image: "https://photos2019.tass.ru/images/ok.png"
					},
					facebook: {
						image: "https://photos2019.tass.ru/images/fb.png",
						description: " "
					}
				}}
				updatecontentByService={{
					facebook: {
						description: " "
					}
				}}
			/>
		</div>
	);
};

export default Share;
